import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { MessageCircle } from 'lucide-react';

interface ConnectionLinkDialogProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onContinue: () => void;
}

export function ConnectionLinkDialog({ open, onClose, onContinue }: ConnectionLinkDialogProps) {
  const handleContinue = () => {
    onClose();
    onContinue();
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-md bg-background border-border z-[70]">
        <DialogHeader className="text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
            <MessageCircle className="h-7 w-7 text-primary" />
          </div>
          <DialogTitle className="text-xl text-center">Lien de connexion</DialogTitle>
          <DialogDescription className="text-center text-muted-foreground pt-2">
            Vous recevrez le lien de connexion à vos réseaux sociaux directement dans votre<span className="font-medium text-foreground"> conversation</span> après votre onboarding.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4 sm:justify-center">
          <Button onClick={handleContinue} className="w-full sm:w-auto">
            Continuer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
